export default {
  text: {
    order_cancelled: 'Comandă anulată - Niciun șofer disponibil',
    wolt_support: 'Întrebări? Sună Wolt direct <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENT:</strong> Acceptă sau respinge această comandă imediat',
    no_driver_found: '<strong>Niciun curier găsit.</strong> Livrează tu comanda sau anuleaz-o',
  },
  labels: {
    dummy_order: 'Comandă de test',
    items_one: '{{count}} produs',
    items_few: '{{count}} articole',
    items_other: '{{count}} produse',
    needs_acceptance: 'Necesită acceptare',
    driver_pending: 'Se așteaptă șoferul',
    driver_search_retrying: 'Se caută încă un curier',
    no_driver_found: 'Niciun curier găsit',
    today: 'Astăzi',
    driver_assigned: 'Șofer alocat',
    complete: 'Finalizată',
  },
  buttons: {
    complete_order: 'Marchează ca finalizată',
    looking_for_driver: 'Se caută un șofer...',
    click_to_remove: 'Click pentru a elimina',
  },
};
